// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56cb923c","239":"e0c2c7e6","453":"2f989ee0","455":"e12823e7"}[chunkId] + ".chunk.js";
};